export const STATE_INITIAL = 'initial';
export const STATE_SENDING = 'sending';
export const STATE_ERROR = 'error';
export const STATE_SENT = 'sent';
